import { format } from "date-fns";

const PROGRAMME_PHASE_MAP = {
  "Standard Intensive": "SI",
  "Remote Intensive": "RI",
  "Remote Ongoing": "RO",
  "Standard Ongoing": "SO",
};

export const ensureArray = <T>(payload: T | T[]): T[] => {
  return Array.isArray(payload) ? payload : [payload];
};

export const getCurrentYear = () => {
  return new Date().getFullYear().toString();
};

export const formatDate = (dateString: string) => {
  const formatted = format(new Date(dateString), "yyyy-MM-dd HH:mm");
  return formatted;
};

export const parseHealthSeekerData = (member: any) => {
  // Simple helper to construct membership information.
  // TODO: This should be handled by the API.
  if (!member) return null;

  return {
    scheme_code: member?.funder?.funder?.scheme_code,
    option_code: member?.funder?.code,
    option_name: member?.funder?.name,
    membership_number: member?.membership_number,
    dependant_code: member?.dependant_key,
    auth_start_date: member?.date_enrolled.replace(/-/g, "/"),
    date_enrolled: member?.date_enrolled,
    health_seeker: {
      names: `${member?.client?.first_name} ${member?.client?.middle_name}`,
      surname: member?.client?.last_name,
      first_name: member?.client?.first_name,
      middle_name: member?.client?.middle_name,
    },
  };
};

export const parseHealthSeekerDataFromCaseRecord = (member: any) => {
  // Simple helper to construct membership information.
  // TODO: This should be handled by the API.
  if (!member) return null;

  return {
    scheme_code: member?.funder?.funder?.scheme_code,
    option_code: member?.funder?.code,
    option_name: member?.funder?.name,
    membership_number: member?.membership_number,
    dependant_code: member?.dependant_key,
    auth_start_date: member?.case_record?.date_enrolled.replace(/-/g, "/"),
    date_enrolled: member?.case_record?.date_enrolled,
    health_seeker: {
      names: `${member?.client?.first_name} ${member?.client?.middle_name}`,
      surname: member?.client?.last_name,
      first_name: member?.client?.first_name,
      middle_name: member?.client?.middle_name,
    },
  };
};

export const parseTariffCodeData = (tariffRate: any) => {
  // Simple helper to construct tariff information.
  // TODO: This should be handled by the API.
  if (!tariffRate || !tariffRate.tariff_code) {
    return {
      code: null,
      practice_types: [],
    };
  }
  console.log(`Parsing Tariff Code: `, tariffRate);
  return {
    code: tariffRate.tariff_code.code,
    description: tariffRate.tariff_code.code_description,
    practice_types: tariffRate.practice_type || [],
  };
};

/**
 * Adds tariff codes to a single member
 * @param {Object} member - The member object
 * @param {Array} tariffCodes - Array of tariff code objects
 * @returns {Object} Member object with tariff_codes added
 */
export const addTariffCodesToMember = (member, tariffCodes) => {
  if (!member || !Array.isArray(tariffCodes)) {
    return {
      ...member,
      tariff_codes: [],
    };
  }

  return {
    ...member,
    tariff_codes: tariffCodes,
  };
};

/**
 * Adds tariff codes to multiple members
 * @param {Array} members - Array of member objects
 * @param {Array} tariffCodes - Array of tariff code objects
 * @returns {Array} Array of members with tariff_codes added
 */
export const addTariffCodesToMembers = (members, tariffCodes) => {
  if (!Array.isArray(members)) {
    return [];
  }

  return members.map((member) => addTariffCodesToMember(member, tariffCodes));
};

export const prepareDataForSync = (members, tariffCodes) => {
  if (!Array.isArray(members) || !Array.isArray(tariffCodes)) {
    return [];
  }
  return { members: members, tariff_codes: tariffCodes };
};

export const prepareDataForQtyUpdate = (members: any[], code: any) => {
  if (!Array.isArray(members) || !code) {
    return [];
  }
  const data = [];
  members.forEach((member) => {
    const payload = {
      treatment_plan_identifier: member,
      tariff_code: code,
      allowed_quantity: 12, // TODO: Remove hardcoding of Allowed Quantity
    };
    data.push(payload);
  });
  return data;
};

export const filterByTariffCodes = (apiResponse, tariffCodes) => {
  if (!Array.isArray(apiResponse) || !Array.isArray(tariffCodes)) {
    console.error("Both parameters must be arrays");
    return [];
  }

  // Convert tariffCodes to Set for faster lookup (O(1) instead of O(n))
  const codeSet = new Set(tariffCodes.map((code) => code.toUpperCase().trim()));

  return apiResponse.filter((item) => {
    const code = item?.tariff_code?.code;
    return code && codeSet.has(code.toUpperCase().trim());
  });
};

export const toProgrammePhaseCode = (label = "") => {
  return PROGRAMME_PHASE_MAP[label] ?? "";
};

export const toProgrammeEndDate = (code = "") => {
  const INTENSIVE_CODES = ["SI", "RI"];
  const year = INTENSIVE_CODES.includes(code.toUpperCase())
    ? 2080
    : new Date().getFullYear();
  return `${year}-12-31`;
};

export const getDayBefore = (dateStr: string) => {
  console.log("Received Date String: ", dateStr);
  if (!dateStr) return null;
  const date = new Date(dateStr);
  date.setDate(date.getDate() - 1);
  return date.toISOString().split("T")[0];
};
